/**
 * Bridges the Sanity visual-editing overlay's refresh event to Nuxt's data layer.
 *
 * Why a global instead of a direct call: @nuxtjs/sanity inlines the `visualEditing.refresh`
 * option into a virtual module via `.toString()`, so that function cannot reference imports,
 * module scope, or Nuxt auto-imports — `refreshNuxtData` is unreachable from inside it. This
 * plugin publishes the callback on `window`, and the stringified handler in
 * config/nuxt/modules/sanity.ts looks it up by name. The two halves are deliberately kept
 * adjacent so the indirection is findable.
 *
 * Without this, edits in the Studio form never reach the preview: the module's default
 * refresh returns `false` for mutations whenever live preview is enabled, and we run
 * `mode: 'visual-editing'` (no live mode) with content coming from the BFF — so nothing
 * would deliver the update.
 */
export default defineNuxtPlugin(() => {
  // Authors only: never install the hook for ordinary visitors.
  if (!useSanityVisualEditingState()?.enabled) {
    return;
  }

  (window as unknown as Record<string, unknown>).__sanityRefresh = () => refreshNuxtData();
});
